import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewContentType', {
  DEFAULT: 0,
  RESTRICTED: -1
});
